<template>
  <div
    :style="{
      height: containerHeight,
      transitionDuration: duration + 'ms',
      transitionDelay: delay + 'ms',
    }"
    class="ease-fast-effect flex flex-col justify-start overflow-hidden transition-all"
    :class="[direction === 'horizontal' && 'flex-row', direction === 'vertical' && 'flex-col']"
  >
    <div ref="content" class="w-full">
      <slot />
    </div>
  </div>
</template>
<script setup lang="ts">
  import { useElementBounding } from '@vueuse/core'
  import { computed, useTemplateRef } from 'vue'

  interface Props {
    isExtended: boolean
    direction?: 'horizontal' | 'vertical'
    animateOnInit?: boolean
    duration?: number
    delay?: number
    fixedHeight?: number
  }

  const {
    isExtended,
    animateOnInit = false,
    duration = 400,
    delay = 0,
    fixedHeight,
    direction = 'vertical',
  } = defineProps<Props>()

  const content = useTemplateRef('content')
  const { height } = useElementBounding(content)

  const containerHeight = computed(() => {
    if (isExtended && !height.value && !animateOnInit) {
      return 'auto'
    }
    return (isExtended ? (fixedHeight ?? height.value) : 0) + 'px'
  })
</script>
